import { createTheme } from '@mui/material/styles';

const { shadows } = createTheme();

export const boxShadow = {
  none: 'none',
  small: shadows[1],
  medium: shadows[5],
  large: shadows[15],
};
